"use strict";
/**
 * @module parjs/internal
 *
 */ /** */
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../index");
var ConversionHelper;
(function (ConversionHelper) {
    function convert(x) {
        if (typeof x === "string") {
            return index_1.Parjs.string(x);
        }
        else if (x instanceof RegExp) {
            return index_1.Parjs.regexp(x);
        }
        else {
            return x;
        }
    }
    ConversionHelper.convert = convert;
    function isConvertibleFromLiteral(x) {
        return typeof x === "string" || x instanceof RegExp;
    }
    ConversionHelper.isConvertibleFromLiteral = isConvertibleFromLiteral;
})(ConversionHelper = exports.ConversionHelper || (exports.ConversionHelper = {}));
//# sourceMappingURL=convertible-literal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/parjs/internal/convertible-literal.js
// module id = 381
// module chunks = 0 1